module.exports = __webpack_public_path__ + "img/Form.635fe1ba.svg";